export const EventBusType = {
	SETTINGS: "SETTINGS_EVENT_BUS",
	USERS: "USER_EVENT_BUS",
	CUSTOMER_EVENT_BUS: "CUSTOMER_EVENT_BUS",
	API: "API_EVENT_BUS",
	SCHEDULE: "SCHEDULE_EVENT_BUS",
	JOB: "JOB_EVENT_BUS"
};
